// Get the page slug from the provided url
export const getSlugFromURL = (url: string) =>
  url
    .split("/")
    .filter((x: string) => !!x)
    .pop();
